import loadable from '@loadable/component';
export const manifest = {
  StickyTable: {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "StickyTable";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "StickyTable" */
          './sticky-table'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./sticky-table");
            }

            return eval('require.resolve')("./sticky-table");
          }

        }, {
          resolveComponent: m => m.StickyTable
        })
      }
    }
  },
  'StickyTable.Header': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "StickyTableHeader";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "StickyTableHeader" */
          './sticky-table-header'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./sticky-table-header");
            }

            return eval('require.resolve')("./sticky-table-header");
          }

        }, {
          resolveComponent: mod => mod.StickyTableHeader
        })
      }
    }
  },
  'StickyTable.Row': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "StickyTableRow";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "StickyTableRow" */
          './sticky-table-row'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./sticky-table-row");
            }

            return eval('require.resolve')("./sticky-table-row");
          }

        }, {
          resolveComponent: mod => mod.StickyTableRow
        })
      }
    }
  }
};